import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Inset from 'syf-component-library/ui/spacing/Inset/Inset';
import { useTranslation } from 'react-i18next';
import { ButtonContainer, Content, CrossBorderButton, CrossBorderSimpleModal, Title } from './subcomponents';
export const crossBorderModalId = 'ps-cross-border-modal';
const popupButtonSharedAnalytics = {
    'data-analytics': 'clicktrackingevent',
    'data-object': 'button',
    'data-type': 'payment security'
};
/**
 * @param {string} containerId The Id of the container where the popup will be rendered
 */
const CrossBorderModal = ({ isOpen, closeModal, containerId, tokenDetails, setTokenDetails }) => {
    const { t } = useTranslation();
    const handlePopupClose = () => {
        if (tokenDetails.shouldFetchToken) {
            setTokenDetails({ ...tokenDetails, shouldFetchToken: false });
        }
        closeModal();
    };
    const handleHandshakeRedirect = () => {
        if (!tokenDetails.shouldFetchToken) {
            setTokenDetails({ ...tokenDetails, shouldFetchToken: true });
        }
    };
    return (_jsx(CrossBorderSimpleModal, { "aria-labelledby": "modal-header", containerId: containerId, id: crossBorderModalId, "data-testid": crossBorderModalId, isOpen: isOpen, escapeModalHandler: closeModal, children: _jsxs(Inset, { top: "xxlarge", bottom: "large", vertical: "large", children: [_jsx(Title, { weight: "bold", children: t('crossBorder.title') }), _jsx(Inset, { top: "medium", bottom: "xlarge", children: _jsx(Content, { children: t('crossBorder.body') }) }), _jsxs(ButtonContainer, { children: [_jsx(CrossBorderButton, { buttonType: "secondary", onClick: handlePopupClose, "data-reason": "no go back", ...popupButtonSharedAnalytics, children: t('crossBorder.goBackButton') }), _jsx(CrossBorderButton, { buttonType: "primary", onClick: handleHandshakeRedirect, "data-reason": "yes open in new tab", disabled: tokenDetails.isFetchingToken, ...popupButtonSharedAnalytics, children: t('crossBorder.openNewTabButton') })] })] }) }));
};
export default CrossBorderModal;
